import { useT } from "../../../../i18n";
import { toNumberOrNull } from "../../../../utils/energyDevices";
import { KpiTile, formatWatt } from "./EnergyKpi";
import EnergyTimelineChart from "./EnergyTimelineChart";
import "./EnergyInsight.css";

// 큐브 전체 합계 카드. 합계 · 남는 전력 · 배터리 평균은 BE(EnergyTopologyService)가 더해서 내려준
// 값을 그대로 보여준다. 끊긴 장치는 BE 가 합계에서 빼고 reportingCount 로 알려준다.
export default function GroupSummary({ group, fog, devices = [], showPlaceholders = false }) {
  const t = useT();
  const totalGenW = toNumberOrNull(group.totalGenW);
  const totalConsW = toNumberOrNull(group.totalConsW);
  const surplus =
    toNumberOrNull(group.surplusW) ??
    (totalGenW != null && totalConsW != null ? totalGenW - totalConsW : null);
  const memberCount = group.memberCount ?? devices.length;
  const reporting = group.reportingCount ?? devices.length;
  // fog 의 에너지 데이터가 끊겼을 때만 안내. heartbeat 기준 연결 상태는 정보 탭이 보여준다.
  const fogDown = fog != null && (!fog.latest || fog.latest.hasData === false);
  const deficit = surplus != null && surplus < 0;

  return (
    <div className="panel ei-panel ei-group">
      <div className="ei-device-head">
        <span className="ei-role-badge fog">ALL</span>
        <span className="panel-title">{t("energy.group.title")}</span>
      </div>

      {fogDown && !showPlaceholders && (
        <div className="ei-empty-message">
          {t("energy.group.fogDown", { name: fog.name, reporting })}
        </div>
      )}

      {/* 배터리 평균은 두지 않는다 — 큐브 하나가 20%, 하나가 90%면 평균 55%라 위험한 쪽이 가려진다.
          배터리는 큐브 카드마다 보이고, 그룹은 남는 전력 하나만 크게 보여준다. (BE 의 avgSocPercent 는 그대로 온다) */}
      {/* 라벨이 부호를 말한다 — "+100 W 남는 전력" / "50 W 모자라는 전력". 모자라면 빨강에 크기만 적는다("-50"은 라벨과 겹친다).
          배터리를 채우는 중인지 꺼내 쓰는 중인지는 제목 옆 "?" 도움말(Energy.jsx)에 적혀 있다. */}
      <div className="ei-surplus">
        <div>
          <div className="ei-surplus-label">
            {t(deficit ? "energy.group.deficit" : "energy.group.surplus")}
          </div>
          <div className={`ei-surplus-value ${deficit ? "neg" : "pos"}`}>
            {surplus != null && !deficit ? "+" : ""}
            {formatWatt(deficit ? -surplus : surplus)}
            <small> W</small>
          </div>
        </div>
      </div>

      <div className="ei-kpis ei-kpis--2">
        <KpiTile label={t("energy.group.totalGen")} value={totalGenW} unit="W" color="#4ad4a8" />
        <KpiTile label={t("energy.group.totalCons")} value={totalConsW} unit="W" color={group.consumptionPending ? "#FFA500" : "#78aee8"} />
      </div>

      <EnergyTimelineChart history={group.history} forecast={group.forecast} embedded
        deviceLabel={t("energy.group.title")}
        forecastHistory={group.forecastHistory}
        comparisonHour={group.comparisonHour}
        forecastOrigin={group.forecastOrigin} consumptionPending={group.consumptionPending} />

      <div className="ei-foot">{t("energy.group.basis", { total: memberCount, reporting })}</div>
    </div>
  );
}
